import { dt } from "@/daily/strings";
import { RevealedClue } from "@/daily/useDailyGame";
import { CluePill } from "./Pills";

interface ClueLabelsProps {
  clues: RevealedClue[];
  // Desktop shows full clue pills; phones show compact numbered labels.
  large: boolean;
  // The newest clue so far keeps its full sentence on show; the short form
  // alone can be hard to make sense of.
  newestNumber?: number;
  onOpen: (clueNumber: number) => void;
}

// The clues earned so far, stacked in the top-left of the map.
export const ClueLabels = ({ clues, large, newestNumber, onOpen }: ClueLabelsProps) => (
  <div className="ds-clues">
    {clues.map(({ clue, number, isNew }) =>
      large ? (
        <CluePill
          key={number}
          clue={clue}
          number={number}
          isNew={isNew}
          withDetail={number === newestNumber}
          onOpen={() => onOpen(number)}
        />
      ) : (
        <button
          key={number}
          type="button"
          className={`ds-clue-label ${isNew ? "ds-glow" : ""} ${number === newestNumber ? "ds-clue-label--detailed" : ""}`}
          onClick={() => onOpen(number)}
          aria-label={`${dt("clueNumber", { number })}: ${clue.shortFact}. ${dt("tapDetails")}`}
        >
          <span className="ds-clue-label__number">{number}</span>
          <span className="ds-clue-label__text">
            <span className="ds-clue-label__fact">{clue.shortFact}</span>
            {number === newestNumber && <span className="ds-clue-detail">{clue.detail}</span>}
          </span>
        </button>
      )
    )}
  </div>
);
